import React from "react";
import { withStyles } from "@material-ui/styles";
import { Link } from "react-router-dom";
import style from "style";
import NavQuickLinks from "./NavQuickLinks";

const NavBarLeftSection = ({ classes }) => {
  return (
    <div className={classes.navLeft}>
      <Link to="/">
        <img
          style={{ marginRight: "15px" }}
          src="/images/eastwest-logo-2.png"
          alt="EastWest Logo"
        />
      </Link>
      <NavQuickLinks />
    </div>
  );
};

export default withStyles(style)(NavBarLeftSection);
